module KendoWidgets
{
	export class DropDownListOptions implements kendo.ui.DropDownListOptions
	{
		dataTextField?: string;
		dataValueField?: string;
		width?: string | number;
		placeHolder?: string;
		css?: string;
		wrapper?: string | JQuery | Element;

		label?: string;
		labelPosition?: LabelPositionEnum;
		labelClass?: string;
		labelWidth?: number;

		dataSource?: any | any | kendo.data.DataSource;
		enable?: boolean;
		filter?: string;
		height?: number;
		index?: number;
		headerTemplate?: string | Function;
		template?: string | Function;
		valueTemplate?: string | Function;
		text?: string;
		value?: string;
		autoWidth?: boolean;
		nullable?: boolean;
		nullableItemText?: string;
		triggerChangeAtStartup?: boolean;
		textAlign?: TextAlignEnum;

		change?(e: kendo.ui.DropDownListChangeEvent): void;
		close?(e: kendo.ui.DropDownListCloseEvent): void;
		dataBound?(e: kendo.ui.DropDownListDataBoundEvent): void;
		filtering?(e: kendo.ui.DropDownListFilteringEvent): void;
		open?(e: kendo.ui.DropDownListOpenEvent): void;
		select?(e: kendo.ui.DropDownListSelectEvent): void;
	}

	export class DropDownList extends kendo.ui.DropDownList implements KendoWidget, IControlWithDatasource
	{
		public controlType(): ControlTypeEnum { return ControlTypeEnum.DropDownList; }
		private _firstLoad: boolean;

		constructor(element: Element, options?: KendoWidgets.DropDownListOptions)
		{
			if (options == null)
				options = new KendoWidgets.DropDownListOptions();

			if (options.dataTextField == null) options.dataTextField = "text";
			if (options.dataValueField == null) options.dataValueField = "value";
			if (options.width == null) options.width = 190;
			if (options.nullable == null) options.nullable = false;
			if (options.nullableItemText == null) options.nullableItemText = "N/A";
			if (options.textAlign == null) options.textAlign = TextAlignEnum.Left;

			//#region Width
			if (typeof (options.width) == "number")
				options.width = options.width + "px";

			(element as HTMLElement).style.cssText += "width: " + options.width;
			//#endregion

			//#region Nullable
			if (options.nullable && options.dataSource != null)
			{
				let item = new DropDownListItem();
				item.text = options.nullableItemText;
				item.value = "0";
				options.dataSource.unshift(item);
			}
			//#endregion

			//#region CSS
			if (options.css != null)
				(element as HTMLElement).style.cssText += options.css;
			//#endregion

			super(element, options);
			let that = this;
			element.parentElement!.id = element.id + "Parent";
			$(element).parent().addClass("controlParent");

			//#region Trigger change at startup
			if (options.triggerChangeAtStartup == true && options.value != null)
				this.value(options.value, true);
			//#endregion

			//#region Placeholder
			if (options.placeHolder != null)
				$($(element.parentElement!).find(".k-input")).attr('data-content', options.placeHolder);
			//#endregion

			//#region Label
			if (options.label != null && !this._firstLoad)
			{
				this._firstLoad = true;

				$("#" + element.id + "Label").remove();
				let label = document.createElement("label");
				label.id = element.id + "Label";
				$(label).kendoLabel(
					{
						text: options.label,
						color: KendoWidgets.ColorEnum.BlueVettore,
						class: options.labelClass,
						height: 21,
						fontSize: 14,
						width: (options.labelWidth != null) ? options.labelWidth : "auto"
					});

				//#region Label position
				if (options.labelPosition == null) options.labelPosition = LabelPositionEnum.Top;
				switch (options.labelPosition)
				{
					case LabelPositionEnum.Top:
						{
							$(label).addClass("k-label-top");
							element.parentElement!.style.cssText += "display: inline-flex; flex-direction: column;";
							element.parentElement!.insertBefore(label, element.parentElement!.firstChild);
						}
						break;
					case LabelPositionEnum.Left:
						{
							$(label).addClass("k-label-left");
							element.parentElement!.insertBefore(label, element.parentElement!.firstChild);
							label.style.cssText += "margin-right: 5px";
						}
						break;
					case LabelPositionEnum.Right:
						{
							$(label).addClass("k-label-right");
							element.parentElement!.append(label);
							label.style.cssText += "margin-left: 5px";
						}
						break;
					case LabelPositionEnum.Bottom:
						{
							$(label).addClass("k-label-bottom");
							element.parentElement!.style.cssText += "display: inline-flex; flex-direction: column;";
							element.parentElement!.append(label);
						}
						break;
				}
				//#endregion
			}
			//#endregion

			//#region Text align
			switch (options.textAlign)
			{
				case TextAlignEnum.Left: $(element.parentElement!).find(".k-input").css("text-align", "left"); break;
				case TextAlignEnum.Center: $(element.parentElement!).find(".k-input").css("text-align", "center"); break;
				case TextAlignEnum.Right: $(element.parentElement!).find(".k-input").css("text-align", "right"); break;
			}
			//#endregion

			//#region Wrapper
			if (options.wrapper != null)
				window.setTimeout(() => this.element.parent().wrap(options!.wrapper!));
			//#endregion
		}

		setItems(items: any[])
		{
			if ((this.options as KendoWidgets.DropDownListOptions).nullable)
			{
				let item = new DropDownListItem();
				item.text = (this.options as KendoWidgets.DropDownListOptions).nullableItemText!;
				item.value = "0";
				items.unshift(item);
			}

			if (items == null) items = [];
			this.dataSource.data(items);
		}

		getItems(): any[]
		{
			return this.dataSource.data() as any as any[];
		}

		value(value?: string | number, triggerChange?: boolean)
		{
			if (value != null)
			{
				super.value(String(value));
				if (triggerChange == true)
					this.trigger("change");
			}

			return super.value();
		}

		labelText(text?: string)
		{
			let label = this.element.parent().find(".k-label");
			if (text != null && label != null && label.length > 0)
				label.text(text);

			return (label != null && label.length > 0) ? label.text() : "";
		}

		width(width?: string | number)
		{
			if (width != null)
				this.element.parent().width(width);

			return this.element.parent().width();
		}

		//#region Visible
		show()
		{
			this.visible(true);
		}

		hide()
		{
			this.visible(false);
		}

		visible(visibleStatus?: boolean)
		{
			if (visibleStatus != null)
			{
				if (visibleStatus)
					this.element.parent().show();
				else
					this.element.parent().hide();
			}

			return this.element.parent().is(":visible");
		}
		//#endregion

		/**
		 * @param itemOrId: if the structure contains "id" property you can pass the id (string or number), otherwise
		 * you have to pass the item from dataSource
		 */
		removeItem(itemOrId: any | string | number)
		{
			if (typeof itemOrId == "string" || typeof itemOrId == "number")
			{
				let foundedItem = this.dataSource.data().filter(k => (k as any).id == itemOrId)[0];
				this.dataSource.data().remove(foundedItem);
			}
			else
				this.dataSource.data().remove(itemOrId);
		}

		removeItems(items: any[])
		{
			for (let item of items)
				this.dataSource.data().remove(item);
		}

		clear()
		{
			this.select(0);
		}

		clearItems()
		{
			this.dataSource.data([]);
		}

		isEmpty()
		{
			return (this.value() == null || this.value() == "" || this.value() == "0");
		}

		selectedItem()
		{
			return this.getItems().filter(k => k.value == String(this.value()))[0];
		}

		appendTo(element: string | HTMLElement | JQuery)
		{
			this.element.parent().appendTo(element);
		}

		prependTo(element: string | HTMLElement | JQuery)
		{
			this.element.parent().prependTo(element);
		}
	}

	DropDownList.fn = DropDownList.prototype;
	DropDownList.fn.options = $.extend(true, {}, kendo.ui.DropDownList.fn.options);
	DropDownList.fn.options.name = "DropDownList";
	kendo.ui.plugin(DropDownList);

	export class DropDownListItem
	{
		text: string;
		value: string;
	}
}

interface JQuery
{
	kendoDropDownList(options?: KendoWidgets.DropDownListOptions): JQuery;
}